module.exports = __webpack_public_path__ + "img/lg-logo.ccde84c5.png";